const ScrollBackground = () => (
  <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden" aria-hidden="true">
    <div className="absolute inset-0 bg-gradient-to-br from-slate-50 via-white to-cyan-50/50" />
    <div className="absolute inset-0 mesh-bg opacity-[0.45]" />
    <div className="absolute -top-32 right-0 w-[520px] h-[520px] rounded-full bg-cyan-200/25 blur-[100px]" />
    <div className="absolute bottom-0 -left-24 w-[420px] h-[420px] rounded-full bg-teal-200/20 blur-[90px]" />
  </div>
);

export default ScrollBackground;
